/**
 * The phone app's words for its Banking screen (piece 35, *The fourth release*;
 * decision 8060, the owner's answers of 2026-10-26; row T3197), spread into the
 * one string lookup beside the earlier batches' words. A word the web's Banking
 * page already says, such as Banking, Amount in books, Amount in bank feed or
 * Reconcile, is read from the web's own key and is not repeated here.
 */
export const BANKING_PHONE_STRINGS = {
  'mobile.tab.accounting': 'Accounting',
  'mobile.banking.acts': 'Banking acts',
  'mobile.banking.newAccount': 'New Account',
  'mobile.banking.deposit': 'Deposit',
  'mobile.banking.transfer': 'Transfer',
  'mobile.banking.accounts': 'Accounts',
  'mobile.banking.tile.bank': 'Bank Accounts',
  'mobile.banking.tile.card': 'Credit Cards',
  'mobile.banking.tile.none': 'No account of this kind is set up yet.',
  'mobile.banking.reconciledThrough': 'Reconciled through',
  'mobile.banking.toCategorizeOne': 'feed line to categorize',
  'mobile.banking.toCategorizeMany': 'feed lines to categorize',
  'mobile.banking.endingIn': 'ending in',
  'mobile.banking.moneyIn': 'Money in',
  'mobile.banking.moneyOut': 'Money out',
  'mobile.banking.newAccountOnWeb': 'A bank or card account is opened on the web, with New Bank Account on the Banking page. It asks the name, the kind, the ledger account, the institution and the last four digits.',
  'mobile.banking.depositOnWeb': 'A deposit gathers the payments received into one bank line. It is made on the web, from the payments waiting to be banked.',
  'mobile.banking.transferOnWeb': 'A transfer between two of the accounts is recorded on the web, from its feed line on the account’s Uncategorized tab.',
  'mobile.banking.reconcileOnWeb': 'An account is reconciled on the web, with Reconcile on the account’s page, against the ending balance of its bank statement.',
} as const;
